import {AfterViewInit, Directive} from '@angular/core';
import {EventUtils} from '@wba/utils/event.utils';

const ANIMATION_DURATION = 250;

export interface PageInitAbstract {
  afterViewInitFinished?(): void;
}

@Directive()
export abstract class PageInitAbstract implements AfterViewInit {

  ngAfterViewInit() {
    setTimeout(() => {
      const el: HTMLElement = document.getElementById('NAV_ACTIVE_ITEM') || document.getElementById('NAV_0');
      if (el) {
        EventUtils.focus(el, true);
      }
      if (this.afterViewInitFinished) {
        setTimeout(() => this.afterViewInitFinished());
      }
    }, ANIMATION_DURATION);
  }

}
